"use client"

import { GetPageQuery } from "apollo"
import { BlockRenderer, Container, CustomBreadcrumbs, TopBanner } from "ui"
import { findProperty, getBreadCrumbs } from "utils"
import DocumentList from "./DocumentList"
import IconTitleTextContent from "./IconTitleTextContent"
import TitleContent from "./TitleContent"

type Props = {
  data: GetPageQuery
  locale: string
  donationButton: string
}

function Donation({ data, locale, donationButton }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    topBanner: TopBanner,
    basicTitleAndTextBlock: TitleContent,
    donationIconTitleAndText: IconTitleTextContent,
    donationDocumentList: DocumentList,
  }

  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )
  let firstTitleSeen = false
  return (
    <>
      <Container>
        <CustomBreadcrumbs current={selfObject} parents={parents} />
      </Container>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner: hasBanner,
            renderPrompt: index === blocks.length - 1,
            donationButton,
            locale,
          }
        } else {
          let isFirstTitle = false
          if (block.blockType === "basicTitleAndTextBlock" && !firstTitleSeen) {
            isFirstTitle = true
            firstTitleSeen = true
          }
          additionalProps = {
            renderPrompt: index === blocks.length - 1,
            donationButton,
            locale,
            isFirstTitle,
          }
        }

        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}

export default Donation
